import { useState, useCallback } from "react";
import { useAuthenticatedFetchWithWorkspace } from "../../Keycloak/useAuthenticatedFetchWithWorkspace";
import { GetAllTimeslotsResponse, SearchFieldType } from "../../../pages/Marketing/Timeslots/types";

interface GetAllTimeslotsParams {
    page?: number;
    itemsPerPage?: number;
    search?: string;
    searchField?: SearchFieldType;
}

const useGetAllTimeslots = () => {
    const { authFetch, isReady } = useAuthenticatedFetchWithWorkspace();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string>("");
    const [data, setData] = useState<GetAllTimeslotsResponse | null>(null);

    const getAllTimeslots = useCallback(async (params: GetAllTimeslotsParams = {}): Promise<GetAllTimeslotsResponse | null> => {
        const { page = 1, itemsPerPage = 10, search, searchField = 'entity_name' } = params;
        setLoading(true);
        setError("");
        try {
            const queryParams = new URLSearchParams({
                page: page.toString(),
                itemsPerPage: itemsPerPage.toString(),
            });
            const trimmedSearch = search?.trim();
            if (trimmedSearch) {
                queryParams.set(searchField, trimmedSearch);
            }
            const result: GetAllTimeslotsResponse = await authFetch(`/getAllTimeslots?${queryParams.toString()}`, {
                method: "GET",
            });
            setData(result);
            return result;
        } catch (err: unknown) {
            setError(err instanceof Error ? err.message : "An unknown error occurred");
            return null;
        } finally {
            setLoading(false);
        }
    }, [authFetch]);

    return { getAllTimeslots, loading, error, data, isReady };
};

export default useGetAllTimeslots;
